module.exports = __webpack_public_path__ + "img/圆组装饰@2x.4f572181.png";